import React from "react";
import styled from "styled-components";
import {PRIMARY} from "../../../vars/vars";

const Price = ({vat, isVatIncluded}) => (
    <StyledWrapper>
        <StyledPrice>&euro; {vat}</StyledPrice>
        {
            isVatIncluded ? <VAT>Price including VAT</VAT> : <></>
        }

    </StyledWrapper>
);

export default Price;

const StyledWrapper = styled.div`
  width: 100%;
`;

const VAT = styled.div`
  color: #666666;
  font-size: 12px;
  font-family: "Open Sans", sans-serif;
  margin-bottom: 10px;
`;

const StyledPrice = styled.div`
  font-size: 30px;
  line-height: 30px;
  color: ${PRIMARY};
  font-weight: 700;
  font-family: "Open Sans", sans-serif;
`;
